
import React from "react";

import ExportLogs from "../component/ExportLogs";

const ExportLogsContainer = ({ pageId }) => (<ExportLogs pageId={ pageId } />)

export default ExportLogsContainer; 